import Vue from "vue";
import StacBrowser from "./StacBrowser.vue";
import i18n, { loadDefaultMessages } from './i18n';
import MetadataReorder from "./plugins/metadata-reorder";

Vue.use(MetadataReorder);

export default function init() {
  return loadDefaultMessages().then(() => {
    return new Vue({
      i18n,
      render: h => h(StacBrowser)
    }).$mount("#stac-browser");
  });
}
